import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledSecondHeader = styled.div`
  width: 100%;
  height: ${(props) => props.theme.secondHeaderHeight};
  background-color: ${(props) => props.theme.white};
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 120;
  display: flex;
  min-width: 0;
  box-shadow: 0px 4px 12px -4px ${({ theme }) => theme.boxShadowColor};

  &.home-header.wholesale-header {
    .sales-label {
      .sales-tag {
        background-color: ${(props) => props.theme.wholesale} !important;
      }
    }

    .content .second-header-btn-wrapper .second-header-cart-total {
      background-color: ${(props) => props.theme.wholesale} !important;
    }
  }

  .container {
    padding-left: 50px !important;
    padding-right: 50px !important;
  }

  .second-header-btn-wrapper {
    display: flex;
    align-items: center;
  }

  .profile-button {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 3px 0;
    button {
      padding: 0;
    }
    button:hover {
      background: transparent !important;
      cursor: inherit;
    }
    &:hover {
      cursor: pointer;
    }
    .profile-icon,
    .profile-icon img {
      width: 16px;
      height: 16px;
    }
  }

  .ant-dropdown-menu {
    position: relative;
    top: 7px;
    border-radius: 0px;
  }

  .ant-dropdown-menu-item:hover {
    background-color: ${(props) => props.theme.white} !important;
  }

  .content-wrapper {
    position: relative;
    z-index: 20;
    background-color: ${(props) => props.theme.white};
    display: flex;
    flex-grow: 1;
    min-width: 0;
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${(props) => props.theme.backgroundOverlay};
    z-index: 0;
  }

  .products-link {
    background-color: ${(props) => props.theme.navDark};
    color: ${(props) => props.theme.white};
    border-color: ${(props) => props.theme.navDark};

    &:hover {
      background-color: ${(props) => props.theme.navDark} !important;
      color: ${(props) => props.theme.white} !important;
      border-color: ${(props) => props.theme.navDark} !important;
      opacity: 0.9;
    }

    span {
      color: ${(props) => props.theme.white};
    }

    .ant-btn-icon div {
      height: 21px;
    }
  }

  .listings-link {
    background-color: ${(props) => props.theme.wholesale};
    color: ${(props) => props.theme.white};
    border-color: ${(props) => props.theme.wholesale};

    &:hover {
      background-color: ${(props) => props.theme.wholesale} !important;
      color: ${(props) => props.theme.white} !important;
      border-color: ${(props) => props.theme.wholesale} !important;
      opacity: 0.9;
    }

    span {
      color: ${(props) => props.theme.white};
    }
  }

  .sales-label {
    display: flex;
    align-items: center;
    gap: 6px;

    .sales-tag {
      background-color: ${(props) => props.theme.brand02};
      color: ${(props) => props.theme.white};
      border: none;
      border-radius: 22px;
      font-weight: 600;
      font-size: 17px;
      line-height: 1;
      padding: 2px 8px;
      margin: 0;
    }
  }

  .content {
    height: ${(props) => props.theme.secondHeaderHeight};
    display: flex;
    align-items: center;
    position: relative;
    justify-content: space-between;
    flex-grow: 1;
    height: 104px;
    gap: 50px;

    .block {
      display: flex;
      gap: 10px;
      flex-grow: 1;
      align-items: center;

      .sales-link {
        padding-left: 20px;
        padding-right: 10px;
      }

      .gift-sets-link {
        span {
          font-weight: 600;
        }
      }

      .second-header-btn-wrapper {
        display: flex;
        justify-content: center;

        .second-header-cart-total {
          background-color: ${(props) => props.theme.brand02};
          position: absolute;
          top: 7px;
          border-radius: 10px 10px 10px 0;
          padding: 3px 14px 3px 14px;
          font-size: 12px;
          color: ${(props) => props.theme.white};
          font-family: ${(props) => props.theme.fontText};
          font-weight: 400;
          margin-left: 17px;
        }
      }

      .profile-btn {
        padding-right: 0;
      }
    }

    .block-2 {
      justify-content: flex-end;
    }
  }

  .header-search {
    width: 100%;

    .ant-input-prefix {
      margin-inline-end: 16px;
    }
  }

  .menu-pos {
    position: absolute;
    top: -1px;
    left: 109px;
    width: 0;
  }

  .ant-input-affix-wrapper-lg {
    padding: 8px 12px;
    border-radius: 20px;
    height: 40px;
    width: 100%;
    background-color: ${(props) => props.theme.searchInputBgColor};
    border: none;

    .ant-input {
      font-size: 16px;

      &::placeholder {
        color: ${(props) => props.theme.black};
        opacity: 1;
      }
    }
  }

  &.home-header {
    height: auto;
    flex-direction: column;

    .content-wrapper {
      .container {
        max-width: 100%;
        padding-left: 16px;
        padding-right: 16px;
      }
    }

    .content {
      .block-1,
      .block-2 {
        width: auto;
      }

      .block-1 {
        gap: 8px;

        .home-logo {
          display: inline-flex;
          align-items: center;
          cursor: pointer;
          margin-right: 6px;

          img {
            width: 80px;
            height: auto;
            filter: brightness(0) saturate(0) opacity(0.55);
          }
        }

        .products-link,
        .manufacturers-link,
        .gift-sets-link {
          height: 40px;
          min-height: 40px;
          border-radius: 30px;
          border-width: 1px;
          padding: 10px 16px !important;
          gap: 17px;
        }

        .manufacturers-link {
          background-color: ${(props) => props.theme.eMarket};
        }

        .gift-sets-link {
          border: 1px solid ${(props) => props.theme.menuBorderBottom};
          background-color: ${(props) => props.theme.white};

          &:hover {
            border-color: ${(props) => props.theme.menuBorderBottom} !important;
            background-color: ${(props) => props.theme.white} !important;
          }
        }

        .products-link,
        .manufacturers-link,
        .gift-sets-link {
          span {
            font-weight: 500;
          }
        }
      }

      .block-2 {
        gap: 12px;
      }

      .back-emarket-link {
        margin-left: 12px;
        margin-right: 8px;
        background-color: ${(props) => props.theme.brand02} !important;
        border-color: ${(props) => props.theme.brand02} !important;
        color: ${(props) => props.theme.white} !important;
        height: 40px;

        span {
          color: ${(props) => props.theme.white} !important;
        }

        &:hover {
          background-color: ${(props) => props.theme.brand02} !important;
          border-color: ${(props) => props.theme.brand02} !important;
          color: ${(props) => props.theme.white} !important;
          opacity: 0.9;
        }
      }

      .bizness-link {
        margin-left: 12px;
        margin-right: 8px;
        height: 40px;
        padding: 10px 16px;
        border-radius: 30px !important;
        background-color: ${(props) => props.theme.wholesale} !important;
        border-color: ${(props) => props.theme.wholesale} !important;
        color: ${(props) => props.theme.white} !important;

        span {
          color: ${(props) => props.theme.white} !important;
          font-size: 16px;
          font-weight: 500;
        }

        &:hover {
          background-color: ${(props) => props.theme.wholesale} !important;
          border-color: ${(props) => props.theme.wholesale} !important;
          color: ${(props) => props.theme.white} !important;
          opacity: 0.9;
        }
      }

    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    display: none;
  }

  @media only screen and (max-width: 1700px) {
    .content {
      padding: 0 0;
    }

    .ant-input-affix-wrapper-lg {
      width: 100%;
    }
  }

  @media only screen and (max-width: 1650px) {
    .container {
      padding-left: 16px !important;
      padding-right: 16px !important;
    }
  }

  @media only screen and (max-width: 1500px) {
    &.home-header:not(.wholesale-header) {
      .block-2 .sales-link {
        display: none;
      }
    }
  }

  @media only screen and (max-width: 1400px) {
    .content {
      gap: 20px;
    }
  }

  @media only screen and (max-width: 1300px) {
    &.home-header:not(.wholesale-header) {
      .block-1 .gift-sets-link {
        display: none;
      }
    }
  }
`;
